// An X post the v2 writer composed as a thread. marabot-api ayrshare.service mirrors this for the
// real publish (threadComposed branch) - change both. One tweet per blank-line part, in the writer's order;
// a part over the limit is wrapped at a word; a trailing hashtag-only part rides on the last tweet when it fits.
export const X_TWEET_LIMIT = 275;

const wrapAt = (s: string, limit: number): string[] => {
    const out: string[] = [];
    let rem = s;
    while (rem.length > limit) {
        let idx = rem.lastIndexOf(" ", limit);
        if (idx === -1) idx = limit;
        out.push(rem.slice(0, idx).trim());
        rem = rem.slice(idx).trim();
    }
    if (rem) out.push(rem);
    return out;
};

// The tweets the preview shows for a composed thread: the body's parts, then an in-post footer as one
// tweet with its blank lines folded, as the publisher sends it.
export function composedThreadTweets(body: string, inPostFooter?: string, limit: number = X_TWEET_LIMIT): string[] {
    const footer = String(inPostFooter ?? "").trim().replace(/\n\n/g, "\n");
    return [...splitComposedThread(body, limit), ...(footer ? [footer] : [])];
}

export function splitComposedThread(text: string, limit: number = X_TWEET_LIMIT): string[] {
    const tweets = String(text ?? "")
        .split(/\n\s*\n/)
        .map((p) => p.trim())
        .filter(Boolean)
        .flatMap((p) => (p.length + (p.match(/\n/g) || []).length <= limit ? [p] : wrapAt(p, limit)));
    const last = tweets[tweets.length - 1];
    if (tweets.length > 1 && last && /^(#\w+\s*)+$/.test(last)) {
        const prev = tweets[tweets.length - 2];
        const joined = `${prev}\n${last}`;
        if (joined.length + (joined.match(/\n/g) || []).length <= limit) tweets.splice(tweets.length - 2, 2, joined);
    }
    return tweets;
}
